import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { getMe } from "../services/session";
import { STORAGE_KEYS } from "../config/vars";

const PrivateRoute = ({ children }) => {
    const [status, setStatus] = useState("loading"); // loading | ok | no

    useEffect(() => {
        let isMounted = true;
        (async () => {
            const me = await getMe();
            if (!isMounted) return;
            if (me && me.user_type === "client") {
                try {
                    if (me.client_id) localStorage.setItem("clientId", me.client_id);
                    if (me.name) localStorage.setItem("clientName", me.name);
                    if (me.email) localStorage.setItem("emailForGoogle", me.email);
                    if (me.location_id !== undefined) localStorage.setItem("locationId", me.location_id || "");
                    if (me.network_id !== undefined) localStorage.setItem("networkId", me.network_id || "");
                    if (me.active_context_id !== undefined && me.active_context_id !== null) {
                        localStorage.setItem(STORAGE_KEYS.ACTIVE_CLIENT_CONTEXT_ID, me.active_context_id);
                    }
                    const forceFlag = me.force_password_change ? "true" : "false";
                    localStorage.setItem("forcePasswordChange", forceFlag);
                } catch (_) {
                    // ignore
                }
                setStatus("ok");
            } else {
                setStatus("no");
            }
        })();
        return () => {
            isMounted = false;
        };
    }, []);

    if (status === "loading") return null;
    if (status === "no") return <Navigate to="/" replace />;
    return children;
};

export default PrivateRoute;
